import Box from '@mui/material/Box';
import { Typography, colors } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';
import { DotDivider } from '../../../../common/DotDivider';
import { InactiveTag } from '../../../building-blocks/activity-state/InactiveTag';
import RuleChips from '../../../shared/RuleChips';

interface SfConfigSubtitleProps {
  typeIcon?: ReactNode;
  typeLabel?: string;
  chips?: string[];
  highlightedChips?: string[];
  usage?: number;
  showUsage?: boolean;
  isActive?: boolean;
}

export const SfConfigSubtitle = ({
  typeIcon,
  typeLabel,
  chips,
  highlightedChips,
  usage,
  showUsage,
  isActive,
}: SfConfigSubtitleProps) => {
  const hasChips =
    (chips?.filter((chip) => !!chip).length ?? 0) > 0 || (highlightedChips?.length ?? 0) > 0;

  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={0.5}
      alignItems="center"
      sx={{ svg: { path: { stroke: colors.grey[700] } } }}
    >
      {typeLabel && (
        <>
          {typeIcon}
          <Typography variant="caption" color={colors.grey[700]} whiteSpace="nowrap">
            {typeLabel}
          </Typography>
        </>
      )}

      {hasChips && (
        <>
          <DotDivider />
          <RuleChips
            chips={chips ?? []}
            differentColorChips={highlightedChips ?? []}
            differentColor={colors.grey[120]}
          />
        </>
      )}

      {showUsage && usage !== undefined && (
        <Box display="flex" alignItems="center" gap={0.5}>
          <DotDivider />
          <Typography variant="caption" color={colors.grey[700]}>
            {usage}% usage
          </Typography>
        </Box>
      )}

      {isActive === false && (
        <Box display="flex" alignItems="center" gap={0.5}>
          <DotDivider />
          <InactiveTag isActive={false} />
        </Box>
      )}
    </Box>
  );
};
